import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const WebDevelopment = () => {
  useEffect(() => {
    // Scroll-based navigation highlighting
    const sections = document.querySelectorAll(".tab-data[id]");
    const navLinks = document.querySelectorAll(".nav-selector a");

    const navHighlighter = () => {
      let scrollY = window.pageYOffset;

      sections.forEach((current) => {
        const sectionHeight = current.offsetHeight;
        const sectionTop =
          current.getBoundingClientRect().top + window.pageYOffset - 50;
        const sectionId = current.getAttribute("id");

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
          navLinks.forEach((link) => {
            link.parentElement.classList.remove("active");
            if (link.getAttribute("href") === `#${sectionId}`) {
              link.parentElement.classList.add("active");
            }
          });
        }
      });
    };

    window.addEventListener("scroll", navHighlighter);
    return () => window.removeEventListener("scroll", navHighlighter);
  }, []);

  return (
    <div className="web-development-page">
      <section className="banner-section">
        <div className="intro">
          <div className="intro-bg wow fadeIn" data-wow-delay="0.5s">
            <img
              src="/assets/images/background/intro-bg.jpg"
              alt="Light Background"
            />
          </div>
          <div className="container">
            <h1 className="wow fadeInUp" data-wow-delay="0.5s">
              Web Development
            </h1>
          </div>
        </div>
      </section>

      <section className="top-services-section">
        <div className="container">
          <div className="title">
            <h2 className="wow fadeInUp">
              <span className="gradient-text">Next-Generation</span> Web
              Development Solutions for the Modern Businesss
            </h2>
            <h3 className="wow fadeInUp">How we work</h3>
            <p className="wow fadeInUp">
              At Slash Star, we work collaboratively with our clients to create
              custom web development solutions that meet their unique business
              needs. Our agile approach allows us to be flexible and adapt to
              changing requirements or new insights that emerge throughout the
              development process. Our team of experienced developers,
              designers, and project managers work closely with you to ensure
              that your web application is visually stunning, optimized for
              performance, user experience, and security.
            </p>
          </div>
          <div className="row flex-start wow fadeInUp">
            <div className="col col-4">
              <div className="box">
                <span>01</span>
                <h3>Project ideation</h3>
                <p>
                  We start by listening to your business goals, challenges, and
                  vision for your web application. We learn about your target
                  audience, competitors, and key features you require to create
                  an optimal solution.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>02</span>
                <h3>Planning</h3>
                <p>
                  Based on our initial discussion, we create a detailed project
                  plan that includes timelines, milestones, and deliverables. We
                  collaborate with you to finalize the scope and ensure we're
                  aligned on the project's objectives.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>03</span>
                <h3>Design</h3>
                <p>
                  Once we have a clear understanding of your requirements, we
                  move on to create high fidelity designs. We work
                  collaboratively with you to ensure that the design aligns with
                  your brand and user experience goals.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>04</span>
                <h3>Agile Development</h3>
                <p>
                  We follow an agile development approach, which means we work
                  in sprints to deliver functional pieces of the project, test
                  them, and make adjustments as needed. This allows us to be
                  flexible to changing requirements that emerge throughout the
                  development process.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>05</span>
                <h3>Testing</h3>
                <p>
                  Before we deploy your web application, we thoroughly test it
                  for functionality, usability, security, and performance. We
                  make sure that everything is working as expected, and we
                  conduct user acceptance testing to ensure that the solution
                  meets your business needs.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>06</span>
                <h3>Deployment</h3>
                <p>
                  Once the solution has been tested and approved, we deploy it
                  to the production environment. We provide post-launch support
                  to ensure that everything is running smoothly and offer
                  training to your team to make sure that you're comfortable
                  with managing your new solution.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tabs-section">
        <div className="container wow fadeInUp">
          <div className="row">
            <div className="col col-6 nav-selector">
              <div className="title-small">
                <span>SERVICES</span>
              </div>
              <ul>
                <li>
                  <a href="#section1">Custom Web Development</a>
                </li>
                <li>
                  <a href="#section2">E-commerce</a>
                </li>
                <li>
                  <a href="#section3">CMS</a>
                </li>
                <li>
                  <a href="#section4">Web Portal</a>
                </li>
                <li>
                  <a href="#section5">Cloud-Based Development</a>
                </li>
              </ul>
            </div>
            <div className="col col-6">
              <div className="tab-data" id="section1">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/web/web-custom-web.png"
                    alt="Custom Web Development"
                  />
                </div>
                <h3>Custom Web Development Company</h3>
                <p>
                  We offer custom web development services that are tailored to
                  meet your unique business needs. Our applications are designed
                  to be user-friendly, efficient, and scalable, ensuring that
                  they meet your current and future requirements.
                </p>
                <p>
                  Our team of experienced developers uses the latest
                  technologies and best practices to ensure that your web
                  application is fast, reliable, and secure.
                </p>
                <p>
                  We believe in building meaningful and long-term relationships
                  with our clients and their brands through our creative
                  designs, web development agency and engaging software
                  solutions.
                </p>
              </div>
              <div className="tab-data" id="section2">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/web/web-e-commerce.png"
                    alt="Ecommerce Development"
                  />
                </div>
                <h3>Ecommerce Development</h3>
                <p>
                  Our e-commerce web development solutions enable businesses to
                  create online stores that are fast, secure, and easy to use.
                  We build platforms that are optimized for conversions,
                  ensuring that your customers enjoy a seamless shopping
                  experience.
                </p>
                <p>
                  Our e-commerce web development solutions are optimized for
                  search engines, ensuring that your online store ranks higher
                  on Google and other search engines.
                </p>
              </div>
              <div className="tab-data" id="section3">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/web/web-cms.png"
                    alt="CMS Development"
                  />
                </div>
                <h3>CMS Development Services</h3>
                <p>
                  Our CMS development solutions allow businesses to manage their
                  website content easily and efficiently. Our platforms are
                  designed to be user-friendly, ensuring that you can update
                  your website quickly and effortlessly.
                </p>
                <p>
                  Our CMS development solutions come with advanced analytics and
                  reporting tools, enabling you to track your website's
                  performance and make data-driven decisions.
                </p>
              </div>
              <div className="tab-data" id="section4">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/web/web-portal.png"
                    alt="Web Portal Development"
                  />
                </div>
                <h3>Web Portal Development</h3>
                <p>
                  Our web portal development solutions enable businesses to
                  create centralized platforms that streamline their operations
                  and increase their efficiency. We build portals that are
                  tailored to meet your specific needs, ensuring that you can
                  manage your workflows, communication, and data effectively.
                </p>
                <p>
                  Our web portal development solutions are designed to be
                  mobile-responsive, ensuring that your employees and customers
                  can access your platform from any device.
                </p>
              </div>
              <div className="tab-data" id="section5">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/web/web-cloud.png"
                    alt="Cloud-Based Web Development"
                  />
                </div>
                <h3>Cloud-Based Web Development</h3>
                <p>
                  Our cloud-based web development solutions enable businesses to
                  create scalable, flexible, and cost-effective web
                  applications. We leverage the latest cloud technologies to
                  ensure that your applications are reliable, secure, and
                  accessible from anywhere in the world.
                </p>
                <p>
                  Our cloud-based web development solutions offer automatic
                  scaling and load balancing, ensuring that your web application
                  can handle traffic spikes without downtime or performance
                  issues.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="technology-section">
        <div className="container wow fadeInUp">
          <div className="title-small">
            <span>Technology</span>
          </div>
          <div className="title">
            <h2>
              Empowering Your Business with <br />
              Our <span className="gradient-text">Tech Savvy Stack</span>
            </h2>
          </div>
          <div className="flex-start">
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-react.svg" alt="react" />
              </i>
              <span>React Js</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-angular.svg" alt="angular" />
              </i>
              <span>Angular</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-redux.svg" alt="redux" />
              </i>
              <span>Redux</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-nest-js.svg" alt="nest" />
              </i>
              <span>Nest Js</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-vue.svg" alt="vue" />
              </i>
              <span>Vue JS</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-shopify.svg" alt="shopify" />
              </i>
              <span>Shopify</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-wordpress.svg"
                  alt="wordpress"
                />
              </i>
              <span>Wordpress</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-webflow.svg" alt="webflow" />
              </i>
              <span>Webflow</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-typeScript.svg"
                  alt="typeScript"
                />
              </i>
              <span>Typescript</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-javascript.svg"
                  alt="javascript"
                />
              </i>
              <span>Javascript</span>
            </div>
          </div>
        </div>
      </section>

      <section className="approach-section">
        <div className="container wow fadeInUp">
          <div className="title-small">
            <span>Why Us</span>
          </div>
          <div className="title">
            <h2>
              The Benefits of <span className="gradient-text">Partnering</span>{" "}
              with Us
            </h2>
          </div>
          {/* Desktop */}
          <div className="why-us-content why-us-desktop wow fadeInUp">
            <div className="why-us-datas">
              <div>
                <h3>Highly-skilled developers</h3>
                <p>
                  Our experienced developers create high-quality, scalable apps
                  that meet your business needs and use the latest technologies
                  to stay competitive in the marketplace.
                </p>
              </div>
              <div>
                <h3>Agile project management</h3>
                <p>
                  We use an agile approach to work collaboratively with our
                  clients, adapt to changing requirements, and deliver your app
                  on time and within budget.
                </p>
              </div>
              <div>
                <h3>Fast communication</h3>
                <p>
                  We provide fast communication and updates to keep you informed
                  and involved throughout the development process.
                </p>
              </div>
            </div>
            <div className="why-us-datas">
              <div>
                <h3>Modern technologies</h3>
                <p>
                  We use the latest technologies and development practices to
                  create apps that are optimized for performance, user
                  experience, and security.
                </p>
              </div>
              <div>
                <h3>High security</h3>
                <p>
                  We follow industry-standard security practices and protocols
                  to ensure that your app is secure and protected against cyber
                  threats.
                </p>
              </div>
            </div>

            <div className="why-us-datas">
              <div>
                <h3>Robust security</h3>
                <p>
                  We ensure compliance with leading security standards,
                  including NIST CSF, ISO 27001, HIPAA, and GDPR, to keep your
                  data and your users' data safe and secure.
                </p>
              </div>
            </div>
          </div>
          {/* Mobile */}
          <div className="why-us-content why-us-mobile wow fadeInUp">
            <div>
              <h3>Highly-skilled developers</h3>
              <p>
                Our experienced developers create high-quality, scalable apps
                that meet your business needs and use the latest technologies to
                stay competitive in the marketplace.
              </p>
            </div>
            <div>
              <h3>Agile project management</h3>
              <p>
                We use an agile approach to work collaboratively with our
                clients, adapt to changing requirements, and deliver your app on
                time and within budget.
              </p>
            </div>
            <div>
              <h3>Fast communication</h3>
              <p>
                We provide fast communication and updates to keep you informed
                and involved throughout the development process.
              </p>
            </div>
            <div>
              <h3>Modern technologies</h3>
              <p>
                We use the latest technologies and development practices to
                create apps that are optimized for performance, user experience,
                and security.
              </p>
            </div>
            <div>
              <h3>High security</h3>
              <p>
                We follow industry-standard security practices and protocols to
                ensure that your app is secure and protected against cyber
                threats.
              </p>
            </div>
            <div>
              <h3>Robust security</h3>
              <p>
                We ensure compliance with leading security standards, including
                NIST CSF, ISO 27001, HIPAA, and GDPR, to keep your data and your
                users' data safe and secure.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="portfolio-section projects-section">
        <div className="container">
          <h2>More Projects</h2>
          <div className="portfolio card-deck-js">
            <div className="portfolio-card">
              <Link to="/finutss">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/finutz.svg"
                      alt="Finutss"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Finutss</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/bullz">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/bullz.svg" alt="bullz" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Bullz</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-1" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/telly">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/telly.svg" alt="Telly" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Telly</h3>
                      <div>
                        <span>Web</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-4" />
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WebDevelopment;
